import * as React from 'react';
import { ShuttleItem } from './ShuttleItem';
import { ShuttleContainer } from './ShuttleContainer';
import { ShuttleControls } from './ShuttleControls';
import { ShuttleContext } from './ShuttleContext';
import { useShuttleItemClick } from './hooks/useShuttleItemClick';
import { classNames } from '../../utils/utils';
export const Shuttle = ({ shuttleState, setShuttleState, enableUserSelectionHack = true, className, children, ...rest }) => {
    const { onClick: defaultClickHandler } = useShuttleItemClick({ setShuttleState, shuttleState });
    return (React.createElement(ShuttleContext.Provider, { value: { shuttleState, setShuttleState } },
        React.createElement("div", Object.assign({ className: classNames('shuttle', {
                'shuttle--ush': enableUserSelectionHack,
            }, className), role: "presentation", onClick: defaultClickHandler }, rest), children)));
};
Shuttle.Item = ShuttleItem;
Shuttle.Container = ShuttleContainer;
Shuttle.Controls = ShuttleControls;
